export default "/images/2ebd2299c7a96b02062bcfcca2052d2e.avif";